import { Container, Col, Row } from "react-bootstrap";
import "./instagram.css";

const Instagram = () => {
  return (
    <div>
      <Container>
        <Row className="mt-4">
          <Col>
            <h2>SOCIAL MEDIA FEED</h2>
          </Col>
        </Row>
        <Row>
          <iframe
            src="http://igfeed.seansaliva.com/blog/"
            title="Instagram Feed"
            height={760}
          ></iframe>
        </Row>
      </Container>
    </div>
  );
};

export default Instagram;
